import { render, staticRenderFns } from "./ResetPasswordDlg.vue?vue&type=template&id=26a21e18&scoped=true"
import script from "./ResetPasswordDlg.vue?vue&type=script&lang=js"
export * from "./ResetPasswordDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a21e18",
  null
  
)

export default component.exports